/* NOTE: "Various Brands" and "Assortment" are shared string constants between API and Marketplace
Please be careful when changing them */
/* fallback for brand display if there are multiple */
export const MULTIPLE_BRANDS_DISPLAY_LABEL = 'Assortment';
/* fallback for brand display if brand info is unknown */
export const UNKNOWN_BRANDS_DISPLAY_LABEL = 'Various Brands';
